import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../api/client';
import type { WeightEntry, TrendResult } from '../types';

export function useProgress() {
  const queryClient = useQueryClient();
  const entriesQuery = useQuery({ queryKey: ['weight'], queryFn: () => api.get<WeightEntry[]>('/weight') });
  const trendQuery = useQuery({
    queryKey: ['progress-trend'],
    queryFn: () => api.get<TrendResult>('/progress/trend'),
  });

  function invalidate() {
    queryClient.invalidateQueries({ queryKey: ['weight'] });
    queryClient.invalidateQueries({ queryKey: ['progress-trend'] });
  }

  const addMutation = useMutation({
    mutationFn: (entry: { date: string; weightKg: number; waistCm?: number; note?: string }) =>
      api.post('/weight', entry),
    onSuccess: invalidate,
  });
  const removeMutation = useMutation({
    mutationFn: (id: number) => api.del(`/weight/${id}`),
    onSuccess: invalidate,
  });

  return {
    entries: entriesQuery.data ?? [],
    trend: trendQuery.data ?? null,
    loading: entriesQuery.isLoading || trendQuery.isLoading,
    addEntry: async (entry: { date: string; weightKg: number; waistCm?: number; note?: string }) => {
      await addMutation.mutateAsync(entry);
    },
    removeEntry: async (id: number) => {
      await removeMutation.mutateAsync(id);
    },
    reload: invalidate,
  };
}
